import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../redux/store";

const selectSignInOTP = (state: RootState) => state.signInOTP.value;

export const signInOTPSelector = createSelector(
  [selectSignInOTP],
  (signInOTP) => signInOTP
);
